import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
    '& .player-wrapper': {
      '& .eko-player': {
        [theme.breakpoints.down('md')]: {
          ...theme.mixins.marginLR(pxToRem(-24), pxToRem(-24)),
        },
      },
    },
  },
}));
export default useStyles;
